// @flow
import styled from 'styled-components';

export const Container: any = styled.div``;
export const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
  background-color: #f5f7fa;
`;

export const Title = styled.h2`
  font-size: 2rem;
  color: #303956;
  margin-bottom: 20px;
`;

export const ImageSection = styled.div`
  flex: 1;
  background: url('/assets/login-page.jpeg') no-repeat center center;
  background-size: cover;
  height: 50vh;
  @media (max-width: 768px) {
    height: 100vh;
  }
`;

export const Footer = styled.footer`
  bottom: 0;
  width: 100%;
  padding: 1px;
  text-align: center;
  // background-color: #fff;
`;

export default Container;
